module.exports = __webpack_public_path__ + "img/Icon_schedule_clock.4cc3e044.svg";